import React from "react";
import { useStyles } from "./styles";
import { Link } from "react-router-dom";

export const NewsWidgetMore = ({ children, to, ...props }) => {
  const classes = useStyles(props);
  return (
    <Link to={to} className={classes.more}>
      {children}
    </Link>
  );
};
NewsWidgetMore.muiName = "NewsWidgetMore";
NewsWidgetMore.displayName = "NewsWidgetMore";
export default NewsWidgetMore;
